<div class="blocked-container width-660">
    <div class="blocked-intro-text" [innerHTML]="introText | translate | punctuationWrap"></div>
    <h2 class="blocked-title" [innerHTML]="title | translate | punctuationWrap"></h2>
    <div class="unsubscribed-image">
        <div id="jsonImageIcon" class="lottie blocked-large-image"></div>
    </div>
    <div class="blocked-content" [innerHTML]="description | translate | punctuationWrap"></div>
</div>
<app-cta-container [displayBtnContainer]="showCtaLink" [primaryBtnLabel]="'Context.Unsubscribe.CTA' | translate"
                   [isPrimaryBtnBlue]="true"
                   [isSecondaryBtnHidden]="true"
                   (actionSelected)="nextAction($event)">
</app-cta-container>